import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M6 6h2v12H6V6zm3.5 6l8.5 6V6l-8.5 6z' />
  </>,
  'Tolls'
)
